import axios from 'axios';
import cookieManager from '@/utils/cookieManager';

export function createCoreServices() {
  return {
    baseUrl() { return `${process.env.VUE_APP_BASE_URL}/api`; },
    createUrl(url) {
      if (url.startsWith('http')) return url;
      return `${this.baseUrl()}${url}`;
    },
    async get(url, params = {}) {
      return axios.get(this.createUrl(url), { headers: this.getRequestHeader(), params });
    },
    async downloadBlob(url, data) {
      return axios.post(this.createUrl(url), data, { headers: this.getRequestHeader(), responseType: 'blob' });
    },
    async downloadGetBlob(url) {
      return axios.get(this.createUrl(url), { headers: this.getRequestHeader(), responseType: 'blob' });
    },
    async post(url, data, headers) {
      if (!headers) headers = this.getRequestHeader();
      return axios.post(this.createUrl(url), data, { headers: headers });
    },
    async put(url, data, headers) {
      if (!headers) headers = this.getRequestHeader();
      return axios.put(this.createUrl(url), data, { headers: headers });
    },
    async patch(url, data) {
      return axios.patch(this.createUrl(url), data, { headers: this.getRequestHeader() });
    },
    async delete(url, data) {
      return axios.delete(this.createUrl(url), { headers: this.getRequestHeader(), data: data });
    },
    getRequestHeader(extraItemsToPush = null) {
      const accessToken = cookieManager.get('accessToken');
      const headers = { 'Content-Type': 'application/json' };
      if (accessToken) headers['Authorization'] =  `Bearer ${accessToken}`;
      if (extraItemsToPush !== null) {
        Object.assign(headers, extraItemsToPush);
      }
      return headers;
    },
    getMultipartRequestHeader() {
      const headers = this.getRequestHeader();
      headers['Content-Type'] = 'multipart/form-data';
      return headers;
    },
  };
}
